import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  if (serverTableData.orderBy === null || serverTableData.orderBy === undefined) {
    serverTableData.orderBy = 'dateDemande';
    serverTableData.ascending = 0;
  }
  if (serverTableData.orderBy === 'enseigne') {
    serverTableData.orderBy = 'enseigneNomCommercial';
  }
  if (serverTableData.orderBy === 'campagne') {
    serverTableData.orderBy = 'campagneLibelle';
  }
  return generalTransformer(serverTableData);
}
